<template>
    <div class="layout-topbar">
        <div class="layout-topbar-wrapper">
            <div class="layout-topbar-left">
                <router-link to="/">
                    <div class="layout-topbar-logo" id="logolink" style="cursor: pointer; outline: none">
                        <img id="app-logo" alt="pha-logo" :src="require(`@/assets/images/prohealth.png`)" />
                    </div>
                </router-link>
            </div>

            <div class="layout-topbar-right">
                <a class="menu-button" href="#" @click="$emit('menu-button-click', $event)">
                    <i class="pi pi-bars"></i>
                </a>

                <ul class="layout-topbar-actions">
                    <li class="topbar-item user-profile" :class="{ 'active-topmenuitem': activeTopbarItem === 'profile' }">
                        <a href="#" @click="onTopbarItemClick($event, 'profile')">
                            <Badge class="profile-image text-white mr-2" size="large">
                                <span> <i class="pi pi-user" /></span>
                            </Badge>
                            <div class="profile-info mt-2">
                                <h6>{{ getFullName }}</h6>
                            </div>
                        </a>

                        <ul class="fadeInDown">
                            <li class="layout-submenu-header">
                                <div class="profile-info">
                                    <h6>{{ getFullName }}</h6>
                                </div>
                            </li>
                            <li role="menuitem">
                                <user-profile-button />
                            </li>
                            <li role="menuitem">
                                <a href="#" @click="resetPassword">
                                    <i class="pi pi-key"></i>
                                    <div class="settings-item">
                                        <h6>Reset Password</h6>
                                    </div>
                                </a>
                            </li>
                            <li role="menuitem">
                                <Logout></Logout>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Logout from './components/Logout';
import UserProfileButton from './pages/user/UserProfileButton.vue';
import { mapGetters } from 'vuex';
import { showToast } from '@/helpers/toast-handler';

export default {
    name: 'AppTopbar',
    emits: ['menu-button-click', 'topbar-item-click', 'logout'],
    props: {
        activeTopbarItem: String,
    },
    components: {
        Logout,
        UserProfileButton,
    },
    computed: {
        ...mapGetters('auth', ['getFullName', 'companyLogo', 'isGodUser']),
    },
    methods: {
        onTopbarItemClick(event, item) {
            this.$emit('topbar-item-click', { originalEvent: event, item: item });
            event.preventDefault();
        },
        async resetPassword() {
            await this.$store
                .dispatch('auth/passwordResetRequest')
                .then((res) => {
                    showToast(res, 'Password reset link sent to your email');
                    setTimeout(() => {
                        this.$router.push({ name: 'login' });
                    }, 3000);
                })
                .catch((err) => {
                    showToast({}, err?.data?.message ?? 'Something went wrong');
                });
        },
    },
};
</script>
<style scoped>
.footer-logo {
  width: 130px !important;   
  height: 55px !important;
  object-fit: contain;       
  display: block; 
}
</style>
